import { IHttpRequestConfig, post } from "@/browser";
import { applyHeaders, parseResponse } from "@/core/api";
import { compose } from "@/core/url";
import { CostCalculationDto } from "@/data/payexpress/types/CostCalculationDto";
import { CostsCalculation } from "@/data/payexpress/types/CostCalculator";

export const DEFAULT_PAYMENT_TERM_REDUCTION = 3;

export const API = {
  costCalculation: "/api/costs-calculation",
};

export interface CostCalculatorParams {
  companyId?: number;
  data: CostCalculationDto;
}

export const fetchCostCalculation = (params: CostCalculatorParams, options?: IHttpRequestConfig) => {
  const { companyId, data } = params;

  const url = compose(API.costCalculation, {});

  return post(url, data, applyHeaders({ companyId }, options)).then(parseResponse<CostsCalculation>(CostsCalculation));
};
